module.exports = __webpack_public_path__ + "static/media/glass-cheers.1cfebf0d.svg";